export default {
  label: {
    title: 'Importar arquivo',
    file: 'Arquivo',
    insertFile: 'Selecione o documento',
    cancel: 'Cancelar',
    ok: 'Ok',
    send: 'Enviar',
    clear: 'Limpar',
    requiredValue: 'Valor obrigatório',
    processed: 'Planilha enviada com successo',
    status: 'Status: ',
    totalPosts: 'Total de Publicações: ',
    dataStorageUrl: 'Link da planilha processada: ',
    errorMessage: 'Descrição do erro: ',
  },

  infoLabel: 'Informações do formulário',
  closeLabel: 'Fechar informações',

  upload: {
    error: 'Há erros em posts na planilha, verifique os dados e tente novamente.',
    success: 'Documento carregado com sucesso',
  },

  faq: {
    title: 'Qual o formato da planilha?',
    description: 'A planilha deve estar no formato xlsx.',
  },
  faq2: {
    title: 'Qual é a formatação correta da planilha?',
    description: 'Este componente requer uma planilha em posse da Stilingue, hospedada no Google Sheets.',
  },
  faq3: {
    title: 'Como saber se meus dados foram importados?',
    description: 'O resultado da importação será enviado no e-mail.',
  },
};
